import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class RaymondJamesIntegrationService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getRaymondJamesAccountSearchResults(searchTerms, page) {
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.RAYMOND_JAMES_SEARCH)}?searchTerms=${searchTerms}&page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    importRaymondJamesAccountHoldings(postParams) {
        const url = this.urlsService.INTEGRATIONS.RAYMOND_JAMES_IMPORT_ACCOUNT_HOLDINGS;
        return this.ajaxService.postJsonDataObserveBody(url, postParams);
    }
    activateRaymondJamesIntegration() {
        const url = this.urlsService.INTEGRATIONS.RAYMOND_JAMES_ACTIVATE;
        return this.ajaxService.postJsonDataObserveBody(url, {});
    }
    getRaymondJamesIntegrationStatus() {
        const url = this.urlsService.INTEGRATIONS.RAYMOND_JAMES_INTEGRATION_STATUS;
        return this.ajaxService.getDataObserveBody(url);
    }
}
RaymondJamesIntegrationService.ɵfac = function RaymondJamesIntegrationService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RaymondJamesIntegrationService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
RaymondJamesIntegrationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RaymondJamesIntegrationService, factory: RaymondJamesIntegrationService.ɵfac, providedIn: 'root' });
